import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/home';

interface NavbarProps {
  onOpenSubscribe: () => void;
}

export default function Navbar({ onOpenSubscribe }: NavbarProps) {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 24);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 z-50 w-full border-b transition-colors duration-300 ${
        scrolled
          ? 'border-background-200 bg-background-50/95 backdrop-blur'
          : 'border-transparent bg-transparent'
      }`}
    >
      <div className="mx-auto flex h-16 w-full items-center justify-between px-4 md:px-8">
        <a href="#top" className="group flex items-center gap-2.5">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-file-shield-2-line text-lg" />
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-[17px] font-bold tracking-tight text-foreground-950">
              黑料网曝
            </span>
            <span className="mt-0.5 font-label text-[10px] tracking-[0.32em] text-foreground-500">
              LEAKS · INSIDE
            </span>
          </span>
        </a>

        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="rounded-md px-3 py-2 font-label text-[13.5px] text-foreground-600 transition-colors hover:bg-secondary-100 hover:text-foreground-950"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={onOpenSubscribe}
            className="hidden cursor-pointer whitespace-nowrap rounded-md bg-foreground-950 px-4 py-2 font-label text-[13px] font-medium text-background-50 transition-colors hover:bg-primary-600 md:block"
          >
            订阅线索
          </button>
          <button
            type="button"
            aria-label="打开导航"
            onClick={() => setMenuOpen((prev) => !prev)}
            className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md border border-background-200 bg-background-50 text-foreground-900 md:hidden"
          >
            <i className={menuOpen ? 'ri-close-line text-lg' : 'ri-menu-3-line text-lg'} />
          </button>
        </div>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 pb-4 pt-2 md:hidden">
          <nav className="flex flex-col">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setMenuOpen(false)}
                className="border-b border-background-100 py-3 font-label text-sm text-foreground-700"
              >
                {link.label}
              </a>
            ))}
          </nav>
          <button
            type="button"
            onClick={() => {
              setMenuOpen(false);
              onOpenSubscribe();
            }}
            className="mt-4 w-full cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 font-label text-sm font-medium text-background-50"
          >
            订阅爆料线索
          </button>
        </div>
      )}
    </header>
  );
}